var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-login",attrs:{"height":"auto","outlined":""},on:{"click":function($event){return _vm.loginGoogle()}}},[_vm._v("Ingresar")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f38dd9c","hasScoped":true,"buble":{"transforms":{}}}!./src/components/Login/Login.html
// module id = 731
// module chunks = 0